import React,{useState,useEffect} from 'react'
import clinicService from '../../../../../services/clinic.service'
import { useParams } from 'react-router-dom'
import PatientStats from './PatientStats'
import CommStats from './CommStats'
import AgeGroupStats from './AgeGroupStats'
function StatsTab() {
  const [clinicStats,setClinicStats] = useState({})
    const {clinicId} = useParams()

  useEffect(()=>{
        clinicService.getPatientStats(clinicId)
        .then(res=>{
            setClinicStats(res.data)
            console.log("Patient Stats")
            console.log(res.data)
        })
        .catch(err=>{
            console.log(err)
        })
  },[])
    return (
    <>

             <h5 className="card-title" style={{ color: "#012970" }}>
              Stats
            </h5>
            <hr/>
            <div className="row">
                <div className="col-4">
                {clinicStats && clinicStats.patient? <PatientStats patientData={clinicStats.patient}/> :""
            }   
                </div>
                <div className="col-4">
                {clinicStats && clinicStats.commPref?<CommStats commprefs={clinicStats.commPref}/>:""}
                </div>
                <div className="col-4">
                {clinicStats && clinicStats.ageGroup?<AgeGroupStats agegroup={clinicStats.ageGroup}/>:""}
                </div>
            </div>
           
          
            
    </>
  )
}

export default StatsTab